'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _expiredSessionModal = require('../../src/styles/expired-session-modal.scss');

var _expiredSessionModal2 = _interopRequireDefault(_expiredSessionModal);

require('../../src/styles/external.scss');

require('../../src/styles/vars.scss');

var _doctifyModal = require('./doctify-modal');

var _doctifyModal2 = _interopRequireDefault(_doctifyModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { FormattedMessage } from 'react-intl';

var ExpiredSessionModal = function ExpiredSessionModal(props) {
	return _react2.default.createElement(
		_doctifyModal2.default,
		(0, _extends3.default)({}, props, {
			className: props.className + ' ' + _expiredSessionModal2.default.expiredSessionModal,
			bodyStyles: _expiredSessionModal2.default.body,
			header: _react2.default.createElement(
				'span',
				{ className: _expiredSessionModal2.default.header },
				'Your session has expired'
			) }),
		_react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'button',
				{ className: 'btn solid', onClick: props.closeModal },
				' Continue '
			)
		)
	);
};
// import messages from '../lang/default-messages';

ExpiredSessionModal.propTypes = {
	className: require('react').PropTypes.any,
	closeModal: require('react').PropTypes.func.isRequired
};


ExpiredSessionModal.displayName = 'ExpiredSessionModal';

ExpiredSessionModal.defaultProps = {
	className: 'telephoneModal',
	numbers: []
};

exports.default = ExpiredSessionModal;


// WEBPACK FOOTER //
// ./components/doctify-modals/lib/components/expired-session-modal.js